module.exports = __webpack_public_path__ + "static/kostka_logo-ce95cf351843beac1bc5e99ff9f013f1.png";